import React, { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";

const ShareRedirect: React.FC = () => {
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    // Extract ID from query string: /share?1770707980657093007 → 1770707980657093007
    const imageId = location.search.substring(1);
    if (imageId) {
      history.replace(`/team/${imageId}`);
    } else {
      history.replace("/");
    }
  }, []);

  return null;
};

export default ShareRedirect;
